import { render } from "./AsyncButton.vue?vue&type=template&id=f52de6e0&scoped=true&ts=true"
import script from "./AsyncButton.vue?vue&type=script&lang=ts"
export * from "./AsyncButton.vue?vue&type=script&lang=ts"

import "./AsyncButton.vue?vue&type=style&index=0&id=f52de6e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52de6e0"]])

export default __exports__